module.exports = __webpack_public_path__ + "static/media/icon-pdf.56f03508.svg";